export enum CustomEntityType {

    EXTERNAL_DB_TOKEN_AUTH   = 1

}